import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import styles from './typeTiles.module.scss'

/*
 * Vier Kacheln über der Unternehmensliste (Peter, 31.10.2026): je
 * Unternehmensform die Zahl der registrierten, zu prüfenden und aktivierten
 * Unternehmen. Die Zahlen kommen fertig vom Server
 * (`GET /admin/companies/type-counts`), Landesadmins nur ihr Bundesland.
 *
 * Kurzwahl auf die Filterleiste, kein eigener Zustand: Ein Klick auf eine Zahl
 * setzt die Felder „Unternehmensform“ und „Status“, ein Klick auf den Kopf nur
 * die Unternehmensform. Hervorgehoben wird, was die Filterleiste gerade zeigt.
 */

export const TILE_TYPES = [
	{ key: 'JC', title: 'Junior Company' },
	{ key: 'JCC', title: 'Junior Compact Company' },
	{ key: 'JBC', title: 'Junior Basic Company' },
	{ key: 'JMC', title: 'Junior Mini Company' }
]

export const TILE_STATUSES = [
	{ key: 'NOT_ACTIVATED', label: 'Registered' },
	{ key: 'IS_NEED_REVIEW', label: 'To be checked' },
	{ key: 'ACTIVATED', label: 'Activated' }
]

export default function TypeTiles({ counts, selectedTypes, selectedStatuses, onSelect }) {
	const { t } = useTranslation()
	if (!counts) return null

	const nurTyp = (typ, status) =>
		selectedTypes.length === 1 && selectedTypes[0] === typ && (status ? selectedStatuses.length === 1 && selectedStatuses[0] === status : !selectedStatuses.length)

	return (
		<div className={styles.tiles}>
			{TILE_TYPES.filter(typ => counts[typ.key]).map(typ => {
				const zahlen = counts[typ.key]
				const summe = TILE_STATUSES.reduce((s, st) => s + (zahlen[st.key] || 0), 0)
				return (
					<div key={typ.key} className={clsx(styles.tile, selectedTypes.includes(typ.key) && styles.tileActive)} data-testid={`tile-${typ.key}`}>
						<button type="button" className={styles.head} onClick={() => onSelect(typ.key, null)} aria-pressed={nurTyp(typ.key, null)}>
							<span className={styles.short}>{typ.key}</span>
							<span className={styles.title}>{typ.title}</span>
							<span className={styles.sum}>{summe}</span>
						</button>
						<ul className={styles.rows}>
							{TILE_STATUSES.map(st => (
								<li key={st.key}>
									<button
										type="button"
										className={clsx(styles.row, styles[`row${st.key}`], nurTyp(typ.key, st.key) && styles.rowActive)}
										onClick={() => onSelect(typ.key, st.key)}
										aria-pressed={nurTyp(typ.key, st.key)}
									>
										<span>{t(st.label)}</span>
										<strong>{zahlen[st.key] || 0}</strong>
									</button>
								</li>
							))}
						</ul>
					</div>
				)
			})}
		</div>
	)
}
